export default "__VITE_ASSET__RELn_uqI__"